<template>
    <div>
      <br />
      <div class="container-fluid">
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '7')">7</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '8')">8</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '9')">9</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '4')">4</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '5')">5</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '6')">6</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '1')">1</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '2')">2</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '3')">3</button>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <button type="button" class="btn btn-secondary form-control" @click="$emit('click', ',')">,</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-primary form-control" @click="$emit('click', '0')">0</button>
        </div>
        <div class="col">
          <button type="button" class="btn btn-secondary form-control" @click="$emit('erase')">
            <i class="fas fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  export default {
    props: {

    },

    data() {
      return {
        initialValue: null,
        oldValue: null,
        valid: false,
        showCalculator: false
      }
    },

    created() {

    },

    methods: {
      validateNumValue(val) {
        this.valid = val >= this.min && val <= this.max
        return this.valid
      },

      validateValue(val) {
        this.valid = this.pattern.test(val.trim())
        return this.valid
      },

      updateValue: function (value) {
        if(! this.validateValue(value)) {
          setValueKeepCursor(this.$refs.input, this.oldValue)
          return;
        }


        let formattedValue = formatValue(value)
        let numValue = parseFormattedValue(formattedValue)

        this.validateNumValue(numValue)

        // If the value was not already normalized,
        // manually override it to conform
        if (formattedValue !== value) {
          setValueKeepCursor(this.$refs.input, formattedValue)
        }
        this.oldValue = formattedValue
        // Emit the number value through the input event
        this.$emit('input', numValue)
      }
    }
  }
</script>


<style scoped>
  .col {
    padding: 3px;
  }
  input {
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/InputNumberCalculator.vue